import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { UserStatus } from "../generated/lib-domain/user";
import { URL_PATHS } from "../routes";
import { AppState } from "../store";
import ContractPaidMember from "../pages/ContractPaidMember";

const ContractPaidMemberContainer = (): JSX.Element => {
    const history = useHistory();
    const user = useSelector((state: AppState) => state.myData.user);
    const payment = useSelector((state: AppState) => state.payment);
    const [isShowModal, setIsShowModal] = useState(false);

    // 無料会員
    const freeMember = user.status === UserStatus.Active && !user.isPaid;

    // 有料会員＆web有料登録して未審査
    const paidMember =
        user.isPaid &&
        payment.status.nextPaymentDate != null &&
        payment.status.paidFinishDate == null;

    // 登録会員
    const createdMember = user.status === UserStatus.Created && !user.isPaid;

    // 有料停止
    const paidStopMember =
        user.isPaid &&
        payment.status.nextPaymentDate == null &&
        payment.status.paidFinishDate != null;

    const onClickWithdrawalApply = () => {
        if (paidMember) {
            setIsShowModal(true);
            return;
        }
        history.push(URL_PATHS.withdrawalApply());
    };

    const onClickModalClose = () => {
        setIsShowModal(false);
    };

    return (
        <ContractPaidMember
            paymentStatus={payment.status}
            freeMember={freeMember}
            paidMember={paidMember}
            createdMember={createdMember}
            paidStopMember={paidStopMember}
            isShowModal={isShowModal}
            onClickWithdrawalApply={onClickWithdrawalApply}
            onClickModalClose={onClickModalClose}
        />
    );
};

export default ContractPaidMemberContainer;
